import React from "react";
import { Typography, useTheme } from "@mui/material";
import { SelectionCardProps } from "./types";
import { CardBox } from "./style";

const SelectionCardCst: React.FC<SelectionCardProps> = ({
  title,
  description,
  selected = false,
  disabled = false,
  onSelect,
}) => {
  const theme = useTheme();

  const handleClick = () => {
    if (disabled) return;
    onSelect?.();
  };

  return (
    <CardBox selected={selected} disabled={disabled} onClick={handleClick}>
      <Typography
        sx={{
          fontSize: "18px",
          fontWeight: 700,
          color: theme.palette.primary.main,
          lineHeight: 1.2,
        }}
      >
        {title}
      </Typography>
      {description && (
        <Typography
          sx={{
            fontSize: "13px",
            fontWeight: 400,
            color: theme.palette.text.primary,
            lineHeight: 1.4,
          }}
        >
          {description}
        </Typography>
      )}
    </CardBox>
  );
};

export default SelectionCardCst;
